import { render, staticRenderFns } from "./subList.vue?vue&type=template&id=42d1e051&scoped=true&"
import script from "./subList.vue?vue&type=script&lang=js&"
export * from "./subList.vue?vue&type=script&lang=js&"
import style0 from "./subList.vue?vue&type=style&index=0&id=42d1e051&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d1e051",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d1e051')) {
      api.createRecord('42d1e051', component.options)
    } else {
      api.reload('42d1e051', component.options)
    }
    module.hot.accept("./subList.vue?vue&type=template&id=42d1e051&scoped=true&", function () {
      api.rerender('42d1e051', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/edu/subList.vue"
export default component.exports